import React from 'react';
import { Container, Box, Typography, Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FaBuilding, FaUser, FaArrowRight } from 'react-icons/fa';
import './FinalCTA.css';

const FinalCTA = () => {
  const navigate = useNavigate();

  const handleOrganisationClick = () => {
    navigate('/pour-les-organisations');
  };

  const handleProfessionalClick = () => {
    navigate('/register');
  };

  return (
    <section className="final-cta-section">
      <div className="cta-background">
        <div className="cta-overlay"></div>
      </div>
      
      <Container maxWidth="lg" className="cta-container">
        <Box className="cta-content">
          <Typography variant="h2" className="cta-title">
            Rejoignez Mission Sport dès aujourd'hui
          </Typography>
          <Typography variant="body1" className="cta-subtitle">
            Que vous soyez une organisation sportive ou un professionnel indépendant, 
            votre place est ici. Ensemble, donnons vie à vos projets sportifs.
          </Typography>
          
          <Grid container spacing={4} className="cta-buttons-container">
            <Grid item xs={12} sm={6}>
              <Button 
                variant="contained" 
                size="large" 
                className="cta-button cta-button-organisation"
                onClick={handleOrganisationClick}
                startIcon={<FaBuilding />}
                endIcon={<FaArrowRight />}
                fullWidth
              >
                <div className="button-content">
                  <span className="button-title">Je suis une organisation</span>
                  <span className="button-subtitle">Publier une mission</span>
                </div>
              </Button>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Button 
                variant="outlined" 
                size="large" 
                className="cta-button cta-button-professional"
                onClick={handleProfessionalClick}
                startIcon={<FaUser />}
                endIcon={<FaArrowRight />}
                fullWidth
              >
                <div className="button-content">
                  <span className="button-title">Je suis un professionnel</span>
                  <span className="button-subtitle">Trouver des missions</span>
                </div>
              </Button>
            </Grid>
          </Grid>
          
          <Box className="cta-footer">
            <Typography variant="body2" className="cta-footer-text">
              Inscription gratuite • Mise en relation immédiate • Support dédié
            </Typography>
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default FinalCTA;